module.exports = __webpack_public_path__ + "img/underline.1cd0b9c6.svg";